export function isDef(val) {
  return val !== undefined && val !== null;
}
export function isKorean(text) {
  const reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
  return reg.test(text);
}



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/src/utils/shared.js
// module id = yjlI
// module chunks = 144